import React from 'react';
import * as selectors from '../../reducers';
import PropTypes from 'prop-types';
import styles from './map-banner.module.scss';
import closeIcon from '../../../public/img/close-icon.svg';
import peopleIcon from '../../../public/img/people-icon.svg';
import incomeIcon from '../../../public/img/income-icon.svg';
import ageIcon from '../../../public/img/age-icon.svg';
import adultsObeseIcon from '../../../public/img/adults-obese.svg';
import childrenObeseIcon from '../../../public/img/children-obese.svg';
import atsiIcon from '../../../public/img/atsi.svg';
import eslIcon from '../../../public/img/esl.svg';
import inactiveIcon from '../../../public/img/insufficient-physical-activity.svg';
import { connect } from 'react-redux';

const populationDataItems = [
  {
    name: 'population',
    icon: peopleIcon,
    label: 'people',
    type: 'number',
  },
  {
    name: 'averageIncome',
    icon: incomeIcon,
    label: 'median total income',
    type: 'currency',
  },
  {
    name: 'averageAge',
    icon: ageIcon,
    label: 'median age',
    type: 'number',
  },
  {
    name: 'otherLanguage',
    icon: eslIcon,
    label: 'speaks a language other than English at home',
    type: 'percent',
  },
  {
    name: 'aboriginalPeople',
    icon: atsiIcon,
    label: 'Aboriginal and Torres Straight Islander people',
    type: 'percent',
  },
  {
    name: 'inactivePercentage',
    icon: inactiveIcon,
    label: 'of adults - insufficient physical activity',
    type: 'percent',
  },
  {
    name: 'overweightAdultsPercentage',
    icon: adultsObeseIcon,
    label: 'of adults - overweight or obese',
    type: 'percent',
  },
  {
    name: 'overweightChildrenPercentage',
    icon: childrenObeseIcon,
    label: 'of children - overweight or obese',
    type: 'percent',
  },
];

const MapBanner = ({ council, comparing, onCloseClicked, isMobile }) => {
  const { populationData } = council;
  return (
    <div className={styles.mapBanner} data-comparing={comparing}>
      <button className={styles.closeButton} onClick={onCloseClicked}>
        <img src={closeIcon} alt="" />
      </button>
      <h2 className={styles.mapBannerHeading}>{council.name}</h2>
      <div className={styles.populationData}>
        {populationDataItems.map((x) => {
          return (
            <div className={styles.populationDataItem} key={x.name}>
              <div className={styles.populationDataIcon}>
                <img src={x.icon} alt="" />
              </div>
              <div className={styles.populationDataValue}>
                <div className={styles.number}>
                  {x.type === 'currency' && '$'}
                  {populationData[x.name] < 0
                    ? 'n/a'
                    : populationData[x.name].toLocaleString('en', {
                        useGrouping: true,
                      })}
                  {x.type === 'percent' && populationData[x.name] >= 0 && '%'}
                </div>
                <div className={styles.text}>{x.label}</div>
              </div>
            </div>
          );
        })}
      </div>
      <p className={styles.dataLegend}>
        The data for awarded grants is for the period 1 July 2017 to 29 February
        2020. The data excludes FairPlay vouchers and pass-through grants.
      </p>
    </div>
  );
};

const mapStateToProps = (state) => ({
  isMobile: selectors.getIsMobile(state),
});

MapBanner.propTypes = {
  council: PropTypes.object,
};

export default connect(mapStateToProps, null)(MapBanner);



// WEBPACK FOOTER //
// ./src/components/council-map-container/map-banner.js